import { APP_INITIALIZER, Injectable } from '@angular/core';

const initializeFeatureFlags = (config: FeatureFlagConfiguration) => {
    return (featureFlagService: FeatureFlagService): (() => Promise<void>) => {
        return () => featureFlagService.initialize(config);
    };
};
@Injectable({
    providedIn: 'root'
})
export class FeatureFlagService {
    private readonly flagsUrl = 'https://admin.kylipso.com/flags/';
    private flags = undefined;

    async initialize(config: FeatureFlagConfiguration): Promise<void> {
        const url = `${this.flagsUrl}${config.projectId}/${config.environmentId}.json`;
        try {
            const response = await fetch(url);
            if (!response.ok) {
                console.log(`response code - ${response.status}`);
            } else {
                const flags = await response.json();
                this.flags = flags;
            }
        } catch (error: any) {
            console.log('Error retrieving environment flags. Please ensure that you have published your flags.');
        }
    }

    isFlagActive(flagId: string): boolean {
        if (!this.flags || this.flags[flagId] === undefined) {
            throw new Error(`Error retrieving the ${flagId} flag. Please ensure that you have published your flags.`);
        }

        return this.flags[flagId];
    }
}

export const provideFeatureFlags = (config: FeatureFlagConfiguration): any => {
    return {
        provide: APP_INITIALIZER,
        useFactory: initializeFeatureFlags(config),
        deps: [FeatureFlagService],
        multi: true
    };
};

interface FeatureFlagConfiguration {
    environmentId: string;
    projectId: string;
}
